export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्थिति"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["वेबसाइट"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्टोर आईडी"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्टोर सेटिंग्स"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["भुगतान लिंक"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सक्रिय"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["निष्क्रिय"])}
}